import React from "react";
import StartInspection from "../components/Inspection/Start_inspection";

function Inspection() {
    return (
        <div>
            <StartInspection />
        </div>
    );
}

export default Inspection;